<template>
  <v-menu v-model="menu" :position-x="position.x" :position-y="position.y" :close-on-content-click="false" :nudge-width="600" offset-x>
    <v-form ref="form" style="width: 100%;">
      <v-card>
        <v-card-title class="title py-1">
          <div>
            <div class="pt-1"> {{ type }} stations</div>
            <div class="caption py-1">{{ guidelineName }}</div>
          </div>
          <v-spacer />
          <v-btn class="ma-0" icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="">
          <v-text-field :loading="isSearching" class="emphasize-clear" prepend-inner-icon="search" v-model="search" clearable solo placeholder="Search stations" hide-details>
          </v-text-field>
        </v-card-text>
        <div class="default-border-bottom scroll-border-bottom">
          <v-item-group mandatory v-model="filterToggle" active-class="white--text">
            <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
            <v-item>
              <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="clickable chipFilter" @click="toggle">Available</v-chip>
            </v-item>
            <v-item>
              <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="clickable chipFilter" @click="toggle">
                <div style="float: left;" class="pr-2" :class="{ 'info--text font-weight-bold': formObject.stationIds.length > 0 }">
                  {{ formObject.stationIds.length }}
                </div>
                Selected
              </v-chip>
            </v-item>
          </v-item-group>
        </div>
        <v-card-text>
          <SelectStations ref="selectStations" @isSearching="issearching = $event" :search="search" :filterToggle="filterToggle" :filterToggles="filterToggles" :stations="stations" @selected="onStationSelection" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn color="success" outline @click="submit()">{{$t('Button.Save')}}</v-btn>
          <v-btn outline color="secondary" @click="close()">{{$t('Button.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>

<script>
  import SelectStations from './SelectStations'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import { SOURCE_TYPES } from '@/store/MonitoringFeature/monitoringfeature'

  const dataSources = createNamespacedHelpers('datasource')

  const TYPES = {
    create: 'Add',
    update: 'Edit',
  }

  const guidelineStationExists = 'Guideline already used'

  const filterToggles = {
    available: 0,
    selected: 1,
    unavailable: 2,
  }

  const queryTypes = {
    category: 0,
    station: 1,
  }

  export default {
    components: {
      SelectStations,
    },
    props: {
      configuration: Object,
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
    },
    data: () => ({
      menu: false,
      filterToggles,
      search: '',
      isSearching: false,
      filterToggle: filterToggles.available,
      formObject: {},
      initialObject: {
        guidelineId: null,
        stationIds: [],
      },
      errorMessages: {
        guidelineStations: [],
      },
      type: TYPES.create,
      initialItem: null,
    }),
    computed: {
      ...dataSources.mapGetters(['dataSourceIndex', 'dataSources']),
      rules() {
        return {
          required: (v) => !!v || 'Required',
        }
      },
      discreteStations() {
        return this.dataSources[SOURCE_TYPES.discreteEnvirodata]
      },
      stations() {
        let stations = []
        if (!this.discreteStations) return stations

        stations = this.discreteStations.map(station => {
          return ({
            id: station.Id,
            name: station.PrimaryName,
            normalizedName: station.PrimaryName.toLowerCase(),
            category: station.LocationType,
            type: queryTypes.station,
          })
        })

        return stations
      },
      guidelines() {
        return this.$store.getters['guidelines/guidelineOfCurrentTenant']
      },
      guidelineName() {
        let guideline = this.guidelines.find(g => g.Id == this.formObject.guidelineId)
        if (!guideline) return ''

        return guideline.GuidelineName
      },
    },
    watch: {
      stations: {
        immediate: true,
        handler(value) {
          this.$emit('update:stations', value)
        },
      },
    },
    methods: {
      onStationSelection(selected) {
        let stationIds = []
        Object.values(selected).forEach(category => stationIds.push(...Object.keys(category)))
        this.formObject.stationIds = stationIds
      },
      stationsLength() {
        return this.selectedStations.length
      },
      guidelineStationIndex(v) {
        return this.configuration.guidelineStations.findIndex(gs => gs.guidelineId == v)
      },
      submit() {
        if (!this.$refs.form.validate()) return

        if (this.type == TYPES.create) {
          this.create()
        } else if (this.type == TYPES.update) {
          this.update()
        } else {
          throw 'Unsupported type'
        }
      },
      update() {
        let guidelineStation = JSON.parse(JSON.stringify(this.formObject))
        let index = this.configuration.guidelineStations.findIndex(gs => gs.guidelineId == this.initialItem
          .guidelineId)
        let guidelineStationsIndex = this.guidelineStationIndex(this.initialItem.guidelineId)

        if (index != -1 && guidelineStationsIndex != index) {
          this.errorMessages.guidelineStations = [guidelineStationExists]
          return
        }

        this.errorMessages.guidelineStations = []
        this.configuration.guidelineStations.splice(index, 1, guidelineStation)

        this.close()
      },
      create() {
        let guidelineStation = JSON.parse(JSON.stringify(this.formObject))
        let index = this.guidelineStationIndex(guidelineStation.guidelineId)

        if (index != -1) {
          this.errorMessages.guidelineStations = [guidelineStationExists]
          return
        }

        this.errorMessages.guidelineStations = []
        this.configuration.guidelineStations.push(guidelineStation)

        this.close()
      },
      show(item) {
        if (this.menu) {
          this.close()
          return
        }

        this.type = TYPES.create
        this.menu = true

        this.initialItem = item
        if (item) {
          this.$refs.selectStations.selectStationIds(item.stationIds)
          this.type = TYPES.update

          this.formObject = {
            ...this.formObject,
            ...item,
          }
        } else {
          this.reassign()
        }
      },
      close() {
        this.reassign()
        this.menu = false
      },
      reassign() {
        this.formObject = JSON.parse(JSON.stringify(this.initialObject))
      },
    },
    created() {
      this.formObject = JSON.parse(JSON.stringify(this.initialObject))
      this.reassign()
    },
  }
</script>